<div class="sftp-upload-section" *ngIf="form" [formGroup]="form">
  <div class="form-fields">
    <!-- Row 1: SFTP Host and Port -->
    <div class="form-row">
      <div class="form-field col-6">
        <label for="sftp-host" class="form-label">
          SFTP Host <span class="required">*</span>
        </label>
        <input
          type="text"
          id="sftp-host"
          formControlName="sftpHost"
          class="form-input"
          placeholder="Enter SFTP host"
          [disabled]="readonly"
        />
        <div
          *ngIf="showValidation && !readonly && form.get('sftpHost')?.invalid && form.get('sftpHost')?.touched"
          class="error-message"
        >
          SFTP Host is required
        </div>
      </div>

      <div class="form-field col-6">
        <label for="port" class="form-label">
          Port <span class="required">*</span>
        </label>
        <input
          type="text"
          id="port"
          formControlName="port"
          class="form-input"
          placeholder="Enter port number"
          [disabled]="readonly"
        />
        <div
          *ngIf="showValidation && !readonly && form.get('port')?.invalid && form.get('port')?.touched"
          class="error-message"
        >
          Valid port number is required
        </div>
      </div>
    </div>

    <!-- Row 2: Username and Password -->
    <div class="form-row">
      <div class="form-field col-6">
        <label for="username" class="form-label">
          Username <span class="required">*</span>
        </label>
        <input
          type="text"
          id="username"
          formControlName="username"
          class="form-input"
          placeholder="Enter username"
          [disabled]="readonly"
        />
        <div
          *ngIf="showValidation && !readonly && form.get('username')?.invalid && form.get('username')?.touched"
          class="error-message"
        >
          Username is required
        </div>
      </div>

      <div class="form-field col-6">
        <label for="password" class="form-label">
          Password <span class="required">*</span>
        </label>
        <input
          type="password"
          id="password"
          formControlName="password"
          class="form-input"
          placeholder="Enter password"
          [disabled]="readonly"
        />
        <div
          *ngIf="showValidation && !readonly && form.get('password')?.invalid && form.get('password')?.touched"
          class="error-message"
        >
          Password is required
        </div>
      </div>
    </div>

    <!-- Row 3: Remote Path and Local File Path -->
    <div class="form-row">
      <div class="form-field col-6">
        <label for="remote-path" class="form-label">
          Remote Path <span class="required">*</span>
        </label>
        <input
          type="text"
          id="remote-path"
          formControlName="remotePath"
          class="form-input"
          placeholder="Enter remote path"
          [disabled]="readonly"
        />
        <div
          *ngIf="showValidation && !readonly && form.get('remotePath')?.invalid && form.get('remotePath')?.touched"
          class="error-message"
        >
          Remote Path is required
        </div>
      </div>

      <div class="form-field col-6">
        <label for="local-file-path" class="form-label">
          Local File Path <span class="required">*</span>
        </label>
        <input
          type="text"
          id="local-file-path"
          formControlName="localFilePath"
          class="form-input"
          placeholder="Enter local file path"
          [disabled]="readonly"
        />
        <div
          *ngIf="showValidation && !readonly && form.get('localFilePath')?.invalid && form.get('localFilePath')?.touched"
          class="error-message"
        >
          Local File Path is required
        </div>
      </div>
    </div>

    <!-- Optional Notes/Description -->
    <div class="form-field">
      <label for="optional-notes" class="form-label">
        Optional Notes/Description
      </label>
      <textarea
        id="optional-notes"
        formControlName="optionalNotes"
        class="form-textarea"
        rows="4"
        placeholder="Enter any additional notes or description (optional)"
        [disabled]="readonly"
      ></textarea>
    </div>
  </div>
</div>

